import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeHuExtra from '@angular/common/locales/extra/hu';
import localeHu from '@angular/common/locales/hu';
import { ApplicationConfig, InjectionToken, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef } from '@angular/material/dialog';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import {
    DELIVERY_BACKEND_URL,
    LogLevel,
    provideBreadCrumbConfig,
    provideLanguageConfig,
    provideLoadingOverlay,
    provideNavigationConfig,
    provideSharedConfig,
    provideTranslationConfig
} from '@prekog/common-ui';
import { AppConfigService } from './core/config/app-config.service';
import { routes } from './app.routes';

registerLocaleData(localeHu, 'hu-HU', localeHuExtra);
export const STORE_BACKEND_URL = new InjectionToken<string>('STORE_BACKEND_URL');

export function createAppConfig(): ApplicationConfig {
    const configService = new AppConfigService();
    const config = configService.config;

    return {
        providers: [
            provideZoneChangeDetection({ eventCoalescing: true }),
            provideHttpClient(withInterceptorsFromDi()),
            provideLoadingOverlay(),
            {
                provide: MAT_DIALOG_DEFAULT_OPTIONS,
                useValue: { hasBackdrop: true }
            },
            {
                provide: LOCALE_ID,
                useValue: 'hu-HU'
            },
            {
                provide: MAT_RADIO_DEFAULT_OPTIONS,
                useValue: { color: 'black' }
            },
            { provide: 'ORDER_BACKEND_URL', useValue: config.backendOrderUrl },
            { provide: STORE_BACKEND_URL, useValue: config.backendStoreUrl },
            { provide: 'STORE_BACKEND_URL', useValue: config.backendStoreUrl },
            { provide: 'AUTH_BACKEND_URL', useValue: config.backendAuthUrl },
            { provide: 'CONFIGURATOR_BASE_URL', useValue: config.backendConfiguratorUrl },
            { provide: 'API_URL', useValue: config.apiUrl },
            { provide: 'DOWNLOAD_FILE_URL', useValue: config.downloadUrl },
            { provide: 'FILE_MANAGER_URL', useValue: config.backendFileManagerUrl },
            { provide: 'EMAIL_BACKEND_URL', useValue: config.backendEmailUrl },
            { provide: 'PUBLIC_UI_URL', useValue: config.apiUrl },
            { provide: DELIVERY_BACKEND_URL, useValue: config.backendDeliveryUrl },
            { provide: MatDialogRef, useValue: {} },
            { provide: MAT_DIALOG_DATA, useValue: {} },
            provideAnimationsAsync(),
            provideSharedConfig({
                logLevel: config.logLevel,
                enableUseCaseStatusLogs: config.enableUseCaseStatusLogs,
                logExpirationDays: config.logExpirationDays
            }),
            provideTranslationConfig({ translatedLanguages: ['hu'] }),
            provideLanguageConfig({}),
            provideBreadCrumbConfig({}),
            provideNavigationConfig({}),
            provideRouter(
                routes,
                withInMemoryScrolling({
                    scrollPositionRestoration: 'top',
                    anchorScrolling: 'enabled'
                }),
                withComponentInputBinding()
            )
        ]
    };
}
